import { ImgPcOnlyChat } from '@/assets/icons';
import * as SC from '@/components/common/ViewWhenNotPcSize.style';
import strings from '@/i18n/index';

const ViewWhenNotPcSize = () => {
  return (
    <SC.Wrapper>
      <ImgPcOnlyChat />
      <SC.MainGuide>{strings.MOBILE__.ACCESS_PC_ONLY}</SC.MainGuide>
      <SC.SubGuide>{strings.MOBILE__.GUIDE}</SC.SubGuide>
    </SC.Wrapper>
  );
};

export default ViewWhenNotPcSize;
